import { useState } from 'react';
import Loader from '../../shared/component/Loader';

const Enrichment = ({ handleClose, handleSave, localData, enrichedData, loading }) => {
  // State for storing updated lead data
  const [updateData, setUpdatedData] = useState(localData);
  // State to track which fields are selected
  const [selectedFields, setSelectedFields] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(true); // Initially disabled
  const [selectAll, setSelectAll] = useState(false); // State to track header checkbox

  const handleChange = (e) => {
    const { name, checked } = e.target;

    // Update selected fields state
    setSelectedFields((prev) => {
      const updatedFields = {
        ...prev,
        [name]: checked, // Track if field is checked or not
      };

      // Enable the button if at least one field is checked
      const isAnyFieldChecked = Object.values(updatedFields).some((value) => value === true);
      setIsButtonDisabled(!isAnyFieldChecked); // Disable if none are checked
      // Check if all fields are selected
      const allChecked = Object.keys(enrichedData).every((key) => updatedFields[key] === true);
      setSelectAll(allChecked);

      return updatedFields;
    });

    // Update lead data
    setUpdatedData((prevData) => ({
      ...prevData,
      [name]: checked ? enrichedData[name] : localData[name],
    }));
  };

  // Function to handle "Select All" checkbox
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    // Update selected fields state
    const updatedFields = {};
    const updatedData = { ...localData };

    Object.keys(enrichedData || {}).forEach((key) => {
      if (enrichedData[key]) {
        updatedFields[key] = checked;
        updatedData[key] = checked ? enrichedData[key] : localData[key];
      }
    });

    setSelectedFields(updatedFields);
    setUpdatedData(updatedData);
    setIsButtonDisabled(!checked); // Enable button if at least one is checked
  };

  return (
    <>
      {loading && <Loader />}
      <div id="genricPopup">
        <div className="popup-backdrop" id="leadGen">
          <div className="popup">
            {/* Popup Header */}
            <div className="popup-header">
              <h4 className="popup-title leadTitle">
                Lead Enrichment
                <p>Review and select fields to update for this lead</p>
              </h4>
              <button className="custom-btn-close" onClick={handleClose}></button>
            </div>

            {/* Popup Body */}
            <div className="popup-body  pt-0">
              <div className="popup-body-inner">
                <div className="tableContainer">
                  <table className="table table-striped leadTbl">
                    <thead>
                      <tr>
                        <th width="20px">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={handleSelectAll}
                            checked={selectAll}
                          />
                        </th>
                        <th>Field</th>
                        <th>Existing Value</th>
                        <th>AI-Enrichment Recommendation</th>
                      </tr>
                    </thead>

                    <tbody>
                      {Object.entries(enrichedData || {}).map(
                        ([key, value]) =>
                          value && (
                            <tr key={key}>
                              <td width="20px">
                                <input
                                  name={key}
                                  type="checkbox"
                                  className="form-check-input"
                                  onChange={handleChange}
                                  checked={!!selectedFields[key]}
                                />
                              </td>
                              <td>
                                {key
                                  .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before uppercase letters following lowercase
                                  .replace(/\bLinkdin\b/i, 'LinkedIn') // Ensure "Linkdin" is replaced with "LinkedIn"
                                  .replace(/\b([a-z])/g, (match) => match.toUpperCase()) // Capitalize first letter of each word
                                  .trim()}
                              </td>
                              <td>{localData?.[key]}</td>
                              <td>{value}</td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Popup Footer */}
            <div className="popup-footer">
              <button className="cancel-lead ld-btn" onClick={handleClose}>
                Cancel
              </button>
              <button
                className="save-lead ld-btn"
                onClick={() => handleSave(updateData)}
                disabled={isButtonDisabled || loading} // Disable button when saving
              >
                Update
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Enrichment;
